import React, { Fragment } from 'react'
import CustomSelect from './CustomSelect'
import { useTranslation } from 'react-i18next'
import AttachmentsListItemComponent from './AttachmentsListItemComponent'

const AttachmentsListComponent = ({
  itemKey,
  numberOfAttachments,
  onChangeNumberOfAttachments,
  maximumNumberOfAttachments,
  disableItems,
  attachmentsList,
  onChangeItemValue,
  selectedMoreThanOne,
  onClearTitle
}) => {
  const { t } = useTranslation()
  return (
    <Fragment>
      <CustomSelect
        nonSortedOptions
        key={itemKey}
        name={itemKey}
        value={numberOfAttachments}
        onChange={onChangeNumberOfAttachments}
        title={t('form_builder.elements.number_of_attachments')}
        options={new Array(maximumNumberOfAttachments)
          .fill(1)
          .map((_, idx) => idx + 1)}
        disabled={disableItems}
      />
      {attachmentsList.map((item, index) => (
        <AttachmentsListItemComponent
          disableItems={disableItems}
          onClearTitle={onClearTitle}
          selectedMoreThanOne={selectedMoreThanOne}
          key={index}
          item={item}
          index={index}
          onChangeItemValue={onChangeItemValue}
        />
      ))}
    </Fragment>
  )
}

export default AttachmentsListComponent
